// // sp js
// $('.qtybox .btnqty').on('click', function(){
// var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
// if($(this).hasClass('qtyplus')) {
// qty++;
// }else {
// if(qty > 1) {
// qty--;
// }
// }
// qty = (isNaN(qty))?1:qty;
// $(this).parent('.qtybox').find('.quantity-input').val(qty);
// }); 
// function updateProductQuantities() {
//   jQuery.getJSON('/cart.js', function(cart) {
//     var productHandles = [];
//     cart.items.forEach(function(item) {
//       productHandles.push(item.handle);
//     });
//     $('.grid.grid--uniform .grid__item.grid-product').each(function() {
//       var productHandle = $(this).attr('data-product-handle'); 
//       if (productHandles.includes(productHandle)) {
//         var itemInCart = cart.items.find(function(item) {
//           return item.handle === productHandle;
//         });
//         var quantity = itemInCart.quantity;
//          $(this).find('.qtydiv').css({
//             'opacity': 1,
//             'display': 'block'
//         });// Show the quantity box (opacity 1 means visible)
//         $(this).find('.qtydiv input').val(quantity); // Set the quantity in the input field
//         $(this).find('form.product-single__form').css({
//             'opacity': 0,
//             'display': 'none'
//         });
//       } else {
//         $(this).find('form.product-single__form').css({
//             'opacity': 1,
//             'display': 'block'
//         }); // Show "Add to Cart" button
//        $(this).find('.qtydiv').css({
//             'opacity': 0,
//             'display': 'none'
//         });// Hide the quantity box
//       }
//     });
//   });
// }
// function decreaseCartQuantity(productHandle) {
//   jQuery.getJSON('/cart.js', function(cart) {
//     var itemInCart = cart.items.find(function(item) {
//       return item.handle === productHandle;
//     });
//     if (itemInCart && itemInCart.quantity > 1) {
//       var newQuantity = itemInCart.quantity - 1;
//       jQuery.post('/cart/update.js', {
//         updates: {
//           [itemInCart.id]: newQuantity
//         }
//       }, function() {
//         updateProductQuantities();
//         setTimeout(function() {
//           var cart = new theme.CartDrawer();
//           cart.init();
//           cart.open();
//         }, 300);
//       });
//     }
//   });
// }
// function increaseCartQuantity(productHandle) {
//   jQuery.getJSON('/cart.js', function(cart) {
//     var itemInCart = cart.items.find(function(item) {
//       return item.handle === productHandle;
//     });
//     if (itemInCart) {
//       var newQuantity = itemInCart.quantity + 1;
//       jQuery.post('/cart/update.js', {
//         updates: {
//           [itemInCart.id]: newQuantity
//         }
//       }, function() {
//         updateProductQuantities();
//         setTimeout(function() {
//           var cart = new theme.CartDrawer();
//           cart.init();
//           cart.open();
//         }, 300);
//       });
//     }
//   });
// }
// $(document).on('click', '.grid__item.grid-product .btnqty.qtyminus.icon.icon-minus', function() {
//   var productHandle = $(this).closest('.grid__item.grid-product').attr('data-product-handle');
//   decreaseCartQuantity(productHandle);
// });
// $(document).on('click', '.grid__item.grid-product .btnqty.qtyplus.icon.icon-plus', function() {
//   var productHandle = $(this).closest('.grid__item.grid-product').attr('data-product-handle');
//   increaseCartQuantity(productHandle);
// });
// $(document).ready(function() {
//   updateProductQuantities();
//   setInterval(updateProductQuantities, 1000);
// });






// Flag to prevent multiple cart drawer openings in quick succession
// var isCartDrawerOpen = false;

// // Function to add a product to the cart using AJAX
// function add_to_cart_grid1(variantid, qty) {
// var id = variantid;
// var q = qty;

// var ajax = {
// type: "POST",
// url: "/cart/add.js",
// data: "quantity=" + q + "&id=" + id,
// dataType: "json",
// success: function (n) {
// // Initialize and open the cart drawer only if it's not already open
// if (!isCartDrawerOpen) {
// var cart = new theme.CartDrawer();
// cart.init();
// cart.open();
// isCartDrawerOpen = true;

// // After successfully adding the product, refresh the "You May Also Like" section
// setTimeout(function() {
// refreshYouMayAlsoLike();
// isCartDrawerOpen = false; // Reset flag after 1.5s to allow cart drawer closure
// }, 1500); // Wait for 1.5 seconds to allow cart update
// }
// },
// error: function (n, c) {
// console.log('Add to cart failed');
// }
// };
// jQuery.ajax(ajax);
// }

// // Function to refresh the "You May Also Like" section
// function refreshYouMayAlsoLike() {
// // Use jQuery's load() method to reload the "You May Also Like" section from the current page
// $("#you-may-also-like").load(location.href + " #you-may-also-like > *", function(response, status, xhr) {
// if (status === "success") {
// console.log('You May Also Like section refreshed.');
// // After refresh, hide products already added to the cart
// hideAddedProducts();
// } else {
// console.log('Failed to refresh the You May Also Like section:', xhr.statusText);
// }
// });
// }

// // Function to hide products already added to the cart from the "You May Also Like" section
// function hideAddedProducts() {
// // Get the list of items in the cart
// $.getJSON('/cart.js', function(cart) {
// // Loop through all cart items and hide them from "You May Also Like"
// cart.items.forEach(function(item) {
// var variantId = item.variant_id;
// var productItem = $('#you-may-also-like .product-item').filter(function() {
// return $(this).data('product-id') === variantId;
// });

// // Hide the product if it's found
// if (productItem.length) {
// productItem.hide(); // Hide the product item that was added to the cart
// console.log('Product added to cart, now hidden from recommendations.');
// }
// });
// }).fail(function() {
// console.log('Failed to fetch cart data.');
// });
// }

// // Function to update product quantities in the cart and sync it
// function updateProductQuantities() {
// $.getJSON('/cart.js', function(cart) {
// var productHandles = [];
// cart.items.forEach(function(item) {
// productHandles.push(item.handle);
// });
// $('.grid.grid--uniform .grid__item.grid-product').each(function() {
// var productHandle = $(this).attr('data-product-handle'); 
// if (productHandles.includes(productHandle)) {
// var itemInCart = cart.items.find(function(item) {
// return item.handle === productHandle;
// });
// var quantity = itemInCart.quantity;
// $(this).find('.qtydiv').css({
// 'opacity': 1,
// 'display': 'block'
// }); // Show the quantity box
// $(this).find('.qtydiv input').val(quantity); // Set the quantity
// $(this).find('form.product-single__form').css({
// 'opacity': 0,
// 'display': 'none'
// });
// } else {
// $(this).find('form.product-single__form').css({
// 'opacity': 1,
// 'display': 'block'
// }); // Show "Add to Cart" button
// $(this).find('.qtydiv').css({
// 'opacity': 0,
// 'display': 'none'
// }); // Hide the quantity box
// }
// });
// });
// }

// // Decrease cart quantity
// function decreaseCartQuantity(productHandle) {
// $.getJSON('/cart.js', function(cart) {
// var itemInCart = cart.items.find(function(item) {
// return item.handle === productHandle;
// });
// if (itemInCart && itemInCart.quantity > 1) {
// var newQuantity = itemInCart.quantity - 1;
// $.post('/cart/update.js', {
// updates: {
// [itemInCart.id]: newQuantity
// }
// }, function() {
// updateProductQuantities();
// setTimeout(function() {
// var cart = new theme.CartDrawer();
// cart.init();
// cart.open();
// }, 300);
// });
// }
// });
// }

// // Increase cart quantity
// function increaseCartQuantity(productHandle) {
// $.getJSON('/cart.js', function(cart) {
// var itemInCart = cart.items.find(function(item) {
// return item.handle === productHandle;
// });
// if (itemInCart) {
// var newQuantity = itemInCart.quantity + 1;
// $.post('/cart/update.js', {
// updates: {
// [itemInCart.id]: newQuantity
// }
// }, function() {
// updateProductQuantities();
// setTimeout(function() {
// var cart = new theme.CartDrawer();
// cart.init();
// cart.open();
// }, 300);
// });
// }
// });
// }

// // Event listeners for increasing/decreasing product quantity
// $(document).on('click', '.grid__item.grid-product .btnqty.qtyminus.icon.icon-minus', function() {
// var productHandle = $(this).closest('.grid__item.grid-product').attr('data-product-handle');
// decreaseCartQuantity(productHandle);
// });

// $(document).on('click', '.grid__item.grid-product .btnqty.qtyplus.icon.icon-plus', function() {
// var productHandle = $(this).closest('.grid__item.grid-product').attr('data-product-handle');
// increaseCartQuantity(productHandle);
// });

// // Event listener for Add-to-Cart button click
// $(document).on('click', '.add-to-cart', function() {
// var productItem = $(this).closest('.product-item');
// var variantId = productItem.data('product-id');

// if (variantId) {
// // Call the function to add the product to the cart
// add_to_cart_grid1(variantId, 1);
// } else {
// console.log('Product ID not found!');
// }
// });

// $(document).ready(function() {
// updateProductQuantities();
// setInterval(updateProductQuantities, 1000); // Checking cart updates every second
// });





// setInterval(function () {
// var final_free_text = $("span.final_free_text:first").text();  // Select only the first element
// $(".shipping_saveSP").text(final_free_text);

// $.getJSON('/cart.js', function(cart) {
// var totalPrice = cart.total_price / 100; 
// var finalPrice= totalPrice.toFixed(2);
// if(finalPrice==0){
// $("#AnnouncementSlide-announcement-0 .announcement-text").text("Free Shipping on orders over ₹750 /-");
 
// }
//   else{
//     var progreshbrtext=$("p.shipping_saveSP").text();
// $("#AnnouncementSlide-announcement-0 .announcement-text").text(progreshbrtext);
 
//   }
// })
//   var shippingSaveSP = document.querySelector('.shipping_saveSP');
// if (shippingSaveSP && shippingSaveSP.textContent.trim() === '') {
// document.querySelector('.announcement-bar.cart-slide').classList.add('active-kl');
// } else {
// document.querySelector('.announcement-bar.cart-slide').classList.remove('active-kl');
// }
 
//   }, 1000);

// varint chnage id get product page
setTimeout(function() {
var url = window.location.href;
var variantId = url.match(/[?&]variant=(\d+)/);
if (variantId) {
variantId = variantId[1];
$("span.btnqty-KLSP.qtyplus-KLSP.icon.icon-plus").attr("quantitysp", variantId);
$("span.btnqty-KLSP.qtyminus-KLSP.icon.icon-minus").attr("quantitysp", variantId);
}
}, 500);
$(".variant-input.kl_custom_d").click(function(){
setTimeout(function() {
var url = window.location.href;
var variantId = url.match(/[?&]variant=(\d+)/);
if (variantId) {
variantId = variantId[1];
$("span.btnqty-KLSP.qtyplus-KLSP.icon.icon-plus").attr("quantitysp", variantId);
$("span.btnqty-KLSP.qtyminus-KLSP.icon.icon-minus").attr("quantitysp", variantId);
}
}, 500);
});

